import styles from "./theme-button.module.scss";

const ThemeButton = ({
  className,
  onClick,
  text,
  type,
  disabled,
  ...restProps
}) => {
  return (
    <button
      type={type}
      className={`${className} ${styles.themeButton} ${disabled ? styles.disabled : ""}`}
      onClick={onClick}
      {...restProps}
    >
      {text}
    </button>
  );
};

export default ThemeButton;
